import { HStack, IconButton, Stack, Text, Link } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { useCallback, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { Icon } from "../../components/Icon";
import { useStores } from "../../hooks/useStores";
import VimeoPlayer from "react-player/vimeo";
import { isMobile } from "react-device-detect";
import VimeoIcon from "../../assets/images/vimeo.png";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";

interface RouteParams {
  categoryExternalId: string;
  videoId: string;
}

export const ClientVideoPlayer: React.FC = observer(() => {
  const { categoryExternalId, videoId } = useParams<RouteParams>();
  const { session } = useStores();
  const { t } = useTranslation();
  const history = useHistory();

  const videoCategory = useMemo(() => {
    return session.videoCategories.find(
      (category) => category.externalId === categoryExternalId
    );
  }, [categoryExternalId, session]);

  const video = useMemo(() => {
    return session.videoList.find((video) => video.resourceKey === videoId);
  }, [session, videoId]);

  // useEffect(() => {
  //   ReactGA.pageview(
  //     `/client/video-categories/${categoryExternalId}/video/${videoId}`
  //   );
  // }, [categoryExternalId, videoId]);

  const handleStart = useCallback(() => {
    session.traceActivity({
      externalId: videoId,
      dateTime: new Date(),
      type: "online-traning",
      eventMeta: {
        video,
        status: "started",
      },
    });
    ReactGA.event({
      category: "Customer",
      action: "Allenamento Video Online",
    });
    ReactPixel.track("Allenamento Video Online");
  }, [session, video, videoId]);

  const handleProgress = useCallback(
    (data) => {
      session.traceActivity({
        externalId: videoId,
        dateTime: new Date(),
        type: "online-traning",
        eventMeta: {
          video,
          status: "playing",
          log: data,
        },
      });
    },
    [session, video, videoId]
  );

  const handleEnd = useCallback(() => {
    session.traceActivity({
      externalId: videoId,
      dateTime: new Date(),
      type: "online-traning",
      eventMeta: {
        video,
        status: "end",
      },
    });
  }, [session, video, videoId]);

  return (
    <Stack margin={"2rem"} gridGap={"2rem"}>
      <Stack marginBottom={"2rem"}>
        <Text fontSize="3xl">{video?.name}</Text>
        <HStack>
          <IconButton
            aria-label="Back"
            icon={<Icon iconName={"HiArrowLeft"} />}
            variant={"ghost"}
            onClick={() => history.push("/client/video-categories")}
          />
          <Text fontSize="xl" fontWeight={300}>
            {videoCategory?.name}
          </Text>
        </HStack>
      </Stack>

      <Stack
        justifyContent={"center"}
        flexWrap={"wrap"}
        alignContent={"center"}
        alignItems={"center"}
      >
        {video && (
          <VimeoPlayer
            url={video.link}
            controls
            progressInterval={60000}
            onStart={handleStart}
            onProgress={handleProgress}
            onEnded={handleEnd}
            playing={false}
            width={isMobile ? "100%" : undefined}
          />
        )}

        <HStack justifyContent="center" paddingTop="2rem">
          {isMobile && (
            <Link href={video?.link || ""} isExternal target="_blank">
              <Stack alignContent="center" alignItems="center">
                <img src={VimeoIcon} alt="Vimeo" />
                <span>Riproduci sull'app Vimeo</span>
              </Stack>
            </Link>
          )}
        </HStack>
      </Stack>
    </Stack>
  );
});
